import React from "react";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl text-center shadow-xl overflow-hidden max-w-4xl w-full">
        <div className="p-8 md:p-12">
          <h1 className="text-6xl font-bold text-blue-600 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">
            Oops! Page not found
          </h2>
          <p className="text-gray-600 mb-6">
            The page you're looking for doesn't exist.
          </p>
          <button
            onClick={() => navigate("/sign-in")}
            className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-3 px-6 rounded-lg transition duration-300 w-full md:w-auto"
          >
            Return Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
